export default __webpack_public_path__ + "static/media/LAS0880.34I-39657_-23558_0.5ec6d0f3.jpg";